const styles = () => ({
  priceestimatecard: {
    marginBottom: '2px',
  },
  sectionBlur: {
    filter: 'blur(10px)',
    pointerEvents: 'none',
  },
  veridiCallToAction: {
    top: '0 !important',
    '@media (max-width: 959px)': {
      top: 'unset !important',
    },
  },
  veridiBoligmappaPlusSection: {
    position: 'relative',
  },
  veridiBoligmappaPlusTextSection: {
    width: '65%',
    minHeight: '340px',
    fontSize: '18px',
    '@media (max-width: 959px)': {
      width: '100%',
    },
  },
  greenText: {
    color: '#356E3C',
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
});

export default styles;
